import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { payCalendarsService, UpdatePayCalendarRequest } from '@aslanpay/portal-common-lib';

const useUpdatePayCalendar = ({
  onSuccess,
  onError,
}: UseMutationOptions<unknown, Error, UpdatePayCalendarRequest>) => {
  return useMutation<unknown, Error, UpdatePayCalendarRequest>(
    ({
      id,
      name,
      externalPayCalendarId,
      location,
      currency,
      payFrequency,
      odpAllowancePercentage,
      globalAllowancePercentage,
      startingBalanceDays,
      defaultAnnualGrossSalary,
      startDate,
      payrollCutoff,
      payrollCutoffDays,
      payrollCutoffCustomDay,
      payday,
      paydayLastCustomWeekday,
      paydayFirstCustomWeekday, // NEW: First custom weekday for payday
      paydayCustomDay,
      workingDays,
      payType,
      inArrearsDays,
      payrollCutoffFixedDay,
      paydayFixedDay,
      paydayNonBusinessDayFailover,
      cutoffNonBusinessDayFailover,
      fullPeriodStartingBalance,
      accrualPeriod, // NEW: Accrual period configuration
      salariedDeductionsRequestMadeAvailableConfig, // NEW: Salaried deductions config
      nonSalariedDeductionsRequestMadeAvailableConfig, // NEW: Non-salaried deductions config
      salariedGpeEnabled,
      salariedGpeDaysBeforePaydayCap,
      nonSalariedGpeEnabled,
      nonSalariedGpeDaysBeforePaydayCap,
    }: UpdatePayCalendarRequest) =>
      payCalendarsService.updatePayCalendar({
        id,
        name,
        externalPayCalendarId,
        location,
        currency,
        payFrequency,
        odpAllowancePercentage,
        globalAllowancePercentage,
        startingBalanceDays,
        defaultAnnualGrossSalary,
        startDate,
        payrollCutoff,
        payrollCutoffDays,
        payrollCutoffCustomDay,
        payday,
        paydayLastCustomWeekday,
        paydayFirstCustomWeekday, // NEW: First custom weekday for payday
        paydayCustomDay,
        workingDays,
        payType,
        inArrearsDays,
        payrollCutoffFixedDay,
        paydayFixedDay,
        paydayNonBusinessDayFailover,
        cutoffNonBusinessDayFailover,
        fullPeriodStartingBalance,
        accrualPeriod, // NEW: Accrual period configuration
        salariedDeductionsRequestMadeAvailableConfig, // NEW: Salaried deductions config
        nonSalariedDeductionsRequestMadeAvailableConfig, // NEW: Non-salaried deductions config
        salariedGpeEnabled,
        salariedGpeDaysBeforePaydayCap,
        nonSalariedGpeEnabled,
        nonSalariedGpeDaysBeforePaydayCap,
      }),
    { onSuccess, onError }
  );
};

export default useUpdatePayCalendar;
